import { supabase } from '../lib/supabase';

export const emailService = {
  /**
   * Send booking confirmation email
   */
  async sendBookingConfirmation({
    memberEmail,
    memberName,
    className,
    classTime,
    instructorName,
    duration,
    location,
    tenantName
  }) {
    try {
      const { data, error } = await supabase?.functions?.invoke('send-booking-confirmation', {
        body: {
          memberEmail,
          memberName,
          className,
          classTime,
          instructorName,
          duration,
          location,
          tenantName
        }
      });

      if (error) throw error;
      return { success: true, data };
    } catch (error) {
      console.error('Error sending booking confirmation:', error);
      return { success: false, error: error?.message };
    }
  },

  /**
   * Send class reminder email
   */
  async sendClassReminder({
    memberEmail,
    memberName,
    className,
    classTime,
    instructorName,
    duration,
    location,
    tenantName,
    hoursUntilClass
  }) {
    try {
      const { data, error } = await supabase?.functions?.invoke('send-class-reminder', {
        body: {
          memberEmail,
          memberName,
          className,
          classTime,
          instructorName,
          duration,
          location,
          tenantName,
          hoursUntilClass
        }
      });

      if (error) throw error;
      return { success: true, data };
    } catch (error) {
      console.error('Error sending class reminder:', error);
      return { success: false, error: error?.message };
    }
  },

  /**
   * Send gym announcement to multiple recipients
   */
  async sendGymAnnouncement({
    recipients,
    subject,
    title,
    message,
    tenantName,
    ctaText,
    ctaUrl
  }) {
    try {
      const { data, error } = await supabase?.functions?.invoke('send-gym-announcement', {
        body: {
          recipients,
          subject,
          title,
          message,
          tenantName,
          ctaText,
          ctaUrl
        }
      });

      if (error) throw error;
      return { success: true, data };
    } catch (error) {
      console.error('Error sending gym announcement:', error);
      return { success: false, error: error?.message };
    }
  },

  /**
   * Send cash variance alert with AI analysis
   */
  async sendCashVarianceAlert({
    reconciliationId,
    variance,
    expectedBalance,
    actualBalance,
    drawerName,
    reconciledBy,
    reconciledByEmail,
    tenantName,
    tenantId,
    aiAnalysis,
    transactionPatterns,
    suspiciousFlags
  }) {
    try {
      const { data, error } = await supabase?.functions?.invoke('send-cash-variance-alert', {
        body: {
          reconciliationId,
          variance,
          expectedBalance,
          actualBalance,
          drawerName,
          reconciledBy,
          reconciledByEmail,
          tenantName,
          tenantId,
          aiAnalysis,
          transactionPatterns,
          suspiciousFlags
        }
      });

      if (error) throw error;
      return { success: true, data };
    } catch (error) {
      console.error('Error sending cash variance alert:', error);
      return { success: false, error: error?.message };
    }
  }
};

export default emailService;